export const colors = {
    blue: "#0078F8", // Blue
    purple: "#800080", // Purple
    yellow: "#FCBB00", // Yellow
    orange: "#FF7400", // Orange
    red: "#F00B0B", // Red
    green: "#1CBA00", // Green
    pink: "#FF5DAC", // Pink
    gray: "#9D9D9D", // Gray
    dark_gray: "#717171", // Dark Gray
    teal: "#008080", // Teal
}

